"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalMobile = void 0;
const react_1 = __importStar(require("react"));
// import ReactDOM from "react-dom";
const building_blocks_ui_common_1 = require("@acko-tech/building-blocks.ui.common");
const header_1 = __importDefault(require("./header"));
const duration = 300;
const slideUp = (0, building_blocks_ui_common_1.keyframes) `
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
`;
const slideDown = (0, building_blocks_ui_common_1.keyframes) `
  from {
    transform: translateY(0);
  }
  to {
      transform: translateY(100%);
  }
`;
const ModalWrapper = building_blocks_ui_common_1.styled.div `
  background: ${building_blocks_ui_common_1.$white};
  z-index: 20;
  border-radius: 24px 24px 0 0;
  width: 100%;
  position: fixed;
  ${(props) => props.variant === 'large' ? 'top: 6.5%' : ''};
  bottom: 0;
  left: 0;
  padding: 30px;
  ${(props) => props.isChallanNewFlow
    ? 'overflow-x: hidden; overflow-y: scroll'
    : 'overflow: scroll;'}
  box-sizing: border-box;
  ${(props) => (props.height ? `height: ${props.height}` : '')};
  ${(props) => (props.hideTopPadding ? `padding-top: 0` : '')};
  ${(props) => (props.fullScreen ? `height: 100%; border-radius: 0;` : '')}
  ${(props) => (props.padding ? `padding: ${props.padding}` : '')};
  ${(props) => (props.styles ? props.styles : '')};
  animation: ${(props) => (0, building_blocks_ui_common_1.css) `
      ${props.show ? slideUp : slideDown} ${props.show
    ? props.enterDuration || duration
    : props.exitDuration || duration}ms ease-in-out
    `};
`;
const Overlay = building_blocks_ui_common_1.styled.div `
  height: 100%;
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  z-index: ${(props) => props.zIndex || '10'};
  ${(props) => props.showBackground ? `background-color: rgba(46, 46, 51, 0.66)` : ''};
`;
const ModalBody = building_blocks_ui_common_1.styled.div `
  margin: ${(props) => (props.bodyMargin ? props.bodyMargin : '25px 0 0 0')};
  ${(props) => (props.isChallanNewFlow ? 'height: 100%;' : '')}
`;
const removeBodyStyles = () => {
    // const { top } = document.body.style;
    document.body.setAttribute('style', '');
    // commenting this as page was scrolling to top by deafult when closing modal
    // try {
    //   window.scrollTo(0, Math.abs(parseInt(top || "0", 10)));
    // } catch (err) {
    //   // eslint-disable-next-line no-console
    //   console.log("error: ", err);
    // }
};
const ModalMobileComponent = ({ children, header, show, onHide, variant, hideTopPadding, align, hideCloseButton, height, fullScreen, padding, closeButtonStyles, headerStyles, wrapperStyles, showOverlayBackground, urlhash, enterDuration, exitDuration, bodyMargin, isChallanNewFlow, 
// this prop prevents closing of modal when clicked on modal background (overlay)
disableOverlayClose = false, }) => {
    const onHideHandler = (0, react_1.useCallback)(() => {
        onHide();
    }, []);
    (0, react_1.useEffect)(() => {
        if (show) {
            // const top: number = window.pageYOffset
            // document.body.setAttribute('style', `position: fixed; top: -${top}px`)
        }
        else {
            removeBodyStyles();
        }
        if (typeof window !== 'undefined') {
            if (show) {
                window.location.hash = urlhash;
                window.addEventListener('popstate', onHideHandler);
            }
            else {
                window.removeEventListener('popstate', onHideHandler);
            }
        }
    }, [show]);
    (0, react_1.useEffect)(() => {
        return () => {
            removeBodyStyles();
            if (typeof window !== 'undefined') {
                window.removeEventListener('popstate', onHideHandler);
            }
        };
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        show && (react_1.default.createElement(Overlay, { onClick: disableOverlayClose ? null : onHideHandler, showBackground: showOverlayBackground })),
        show && (react_1.default.createElement(ModalWrapper, { variant: variant, height: height, hideTopPadding: hideTopPadding, fullScreen: fullScreen, padding: padding, styles: wrapperStyles, enterDuration: enterDuration, exitDuration: exitDuration, isChallanNewFlow: isChallanNewFlow, show: show },
            react_1.default.createElement(header_1.default, { closeButton: !hideCloseButton, header: header, onClick: onHideHandler, align: align, hideTopPadding: hideTopPadding, closeButtonStyles: closeButtonStyles, headerStyles: headerStyles }),
            react_1.default.createElement(ModalBody, { bodyMargin: bodyMargin ? bodyMargin : null }, children)))));
};
exports.ModalMobile = (0, react_1.memo)(ModalMobileComponent);
//# sourceMappingURL=modal-mobile.js.map